export enum PRODUCT_TYPE_STRUCTURE_TYPES {
  'COMPLEX' = 'COMPLEX',
  'PIECES_GROUP' = 'PIECES_GROUP',
  'PIECES' = 'PIECES',
  'CATERING_MENU' = 'CATERING_MENU',
  'REQUEST_FORM' = 'REQUEST_FORM',
}

export enum IMAGE_SHAPE {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  SQUARE = 'square',
}

export const IMAGE_SHAPE_WEIGHT = {
  [IMAGE_SHAPE.SQUARE]: 7,
  [IMAGE_SHAPE.HORIZONTAL]: 5,
  [IMAGE_SHAPE.VERTICAL]: 10,
};

export enum CATEGORIES_TYPES {
  BAKERY = 'BAKERY',
  BAKERY_GLOBAL = 'BAKERY_GLOBAL',
  GLOBAL = 'GLOBAL',
}
